import { render, staticRenderFns } from "./sectionPersonnel.vue?vue&type=template&id=6d5024a2&"
import script from "./sectionPersonnel.vue?vue&type=script&lang=js&"
export * from "./sectionPersonnel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports